import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaWhatsapp, FaPen } from 'react-icons/fa';
import { useSchool } from '../contexts/SchoolContext';
import { whatsappLink } from '../config/school';
import './MobileActionBar.css';

// Always-visible Call / WhatsApp / Apply bar on phones (hidden on wider screens via CSS). Uses the school's first
// phone number and first WhatsApp number from School Settings; a button is left out if no number is configured.
const MobileActionBar = () => {
  const { settings } = useSchool();
  const phone = settings.phones[0];
  const whatsapp = settings.phones.find((p) => p.whatsapp);

  return (
    <nav className="mobile-action-bar" aria-label="Quick contact">
      {phone && (
        <a href={`tel:${phone.tel}`}>
          <FaPhone aria-hidden="true" /> Call
        </a>
      )}
      {whatsapp && (
        <a href={whatsappLink(whatsapp.tel)} target="_blank" rel="noopener noreferrer">
          <FaWhatsapp aria-hidden="true" /> WhatsApp
        </a>
      )}
      <Link to="/admissions" className="primary">
        <FaPen aria-hidden="true" /> Apply
      </Link>
    </nav>
  );
};

export default MobileActionBar;
